export default "__VITE_ASSET__Bxh0FIGZ__"